import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button, Table, Spinner, Alert } from "react-bootstrap";
import { getTurnosEnEspera } from "../helpers/rutaTurnos";

const formatFecha = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("es-AR");
};

const getNombreCliente = (row) => {
  // En tu modelo actual el nombre del cliente/persona está en "nombre"
  if (row?.nombre) return row.nombre;

  // compatibilidad por si más adelante cambia el modelo
  if (row?.cliente?.nombre && row?.cliente?.apellido) {
    return `${row.cliente.apellido} ${row.cliente.nombre}`.trim();
  }
  if (row?.cliente?.nombre) return row.cliente.nombre;
  if (row?.nombreCliente) return row.nombreCliente;
  if (row?.clienteNombre) return row.clienteNombre;

  return "";
};

const getNombreUsuario = (row) => {
  if (row?.persona?.nombre) return row.persona.nombre;
  if (row?.usuario) return row.usuario;
  return "";
};

const atencionDesc = (v) => {
  switch (Number(v)) {
    case 0:
      return "SIN DEFINIR";
    case 1:
      return "EN ESPERA";
    case 2:
      return "ATENDIDO";
    case 3:
      return "RECHAZADO";
    default:
      return String(v ?? "");
  }
};

export default function ModalTurnosEnEspera({
  show,
  onHide,
  personaId,
  usuarioNombre,
  refreshKey = 0,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [turnos, setTurnos] = useState([]);

  const cargar = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const data = await getTurnosEnEspera({
        persona: personaId || undefined,
        personal: personaId || undefined,
        usuario: !personaId ? usuarioNombre : undefined,
      });

      // ✅ el helper ya devuelve array
      setTurnos(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error cargando turnos en espera:", err);
      setError("No se pudieron cargar los turnos en espera");
      setTurnos([]);
    } finally {
      setLoading(false);
    }
  }, [personaId, usuarioNombre]);

  useEffect(() => {
    if (show) cargar();
  }, [show, refreshKey, cargar]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Clientes en Espera</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading && (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        )}

        {!loading && error && <Alert variant="danger">{error}</Alert>}

        {!loading && !error && turnos.length === 0 && (
          <Alert variant="success" className="mb-0">
            No hay turnos en espera para esta persona.
          </Alert>
        )}

        {!loading && !error && turnos.length > 0 && (
          <div style={{ maxHeight: "420px", overflowY: "auto" }}>
            <Table bordered hover size="sm" className="align-middle mb-0">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 1,
                }}
              >
                <tr>
                  <th style={{ width: "140px" }}>Fecha</th>
                  <th>Nombre del Cliente</th>
                  <th style={{ width: "220px" }}>Usuario</th>
                  <th style={{ width: "160px" }}>Atención</th>
                </tr>
              </thead>
              <tbody>
                {turnos.map((row) => (
                  <tr key={row._id}>
                    <td>{formatFecha(row.fechaTurno || row.fecha)}</td>
                    <td>{getNombreCliente(row)}</td>
                    <td>{getNombreUsuario(row)}</td>
                    <td>{atencionDesc(row.atencion)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={cargar}>
          Actualizar
        </Button>
        <Button variant="primary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}